// extracted by mini-css-extract-plugin
module.exports = {"theme_toggle":"theme-toggle_theme_toggle__3r4Uz","info_toggle":"theme-toggle_info_toggle__3N7-F"};